import { colors } from '../../colors';
var accordion = {
  bodyBackgroundColor: colors.white,
  iconColor: colors.deepOrange,
  rowBackgroundColor: colors.overcast,
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default accordion;